import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import { SuwasthiLoader } from "../components/loader";
import Pagination from "../components/pagination";
import AssignRoleModal from "../components/assignRoleModal";
import Breadcrumb from "../components/breadcrumb";
import { getCookie } from "../config/webStorage";
  import axios from "axios";
import { useUser } from "../config/userProvider";

const Interviews = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignModal, setAssignModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [role, setRole] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [paginationData, setPaginationData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  let token = getCookie("swtoken");

  const { userData } = useUser();

  useEffect(() => {
    fetchApplications();
  }, [currentPage, itemsPerPage]);

  // const fetchApplications = () => {
  //   setLoading(true);
  //   fetch(
  //     `${apiurl}/api/application/interviews?page=${currentPage}&limit=${itemsPerPage}`
  //   )
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setApplications(data.applications);
  //       setTotalItems(data.pagination?.totalItems || 0);
  //       setTotalPages(data.totalPages);
  //       setLoading(false);
  //       setPaginationData(data?.pagination);
  //       setSelectAll(false);
  //       setSelectedApplications([]);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching applications:", err);
  //       setLoading(false);
  //     });
  // };

    const fetchApplications = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${apiurl}/api/application/interviews`,
        {
          params: { page: currentPage, limit: itemsPerPage },
          headers: { Authorization: `${token}` },
        }
      );

      setApplications(data.applications || []);
      setTotalItems(data.pagination?.totalItems || 0);
      setSelectAll(false);
      setSelectedApplications([]);
    } catch (err) {
      console.error("Error fetching applications:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = (app) => {
    setSelectedApp(app);
    setAssignModal(true);
  };

  const handleView = async (appId, interviewStatus) => {
    try {
      if (interviewStatus === "pending") {
        await fetch(`${apiurl}/api/application/interviews-change-status`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            applicationObjIds: [appId],
            interviewStatus: "running",
          }),
        });

        setApplications((prev) =>
          prev.map((app) =>
            app._id === appId ? { ...app, interviewStatus: "running" } : app
          )
        );
      }

      navigate(`/applications/${appId}/manage`);
    } catch (err) {
      console.error("Error updating interview status:", err);
    }
  };

  const filteredApps = applications.filter((app) => {
    const nameMatch =
      app?.candidateSnapshot?.firstName
        ?.toLowerCase()
        .includes(search.toLowerCase()) ||
      app?.candidateSnapshot?.lastName
        ?.toLowerCase()
        .includes(search.toLowerCase());
    const emailMatch = app?.candidateSnapshot?.email
      ?.toLowerCase()
      .includes(search.toLowerCase());
    return nameMatch || emailMatch;
  });

  const exportToExcel = () => {
    const filteredData = applications.filter((app) => {
      const appDate = new Date(app.createdAt);
      return startDate && endDate && appDate >= startDate && appDate <= endDate;
    });
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");
    XLSX.writeFile(workbook, "Applications.xlsx");
  };

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.1, duration: 0.4 },
    }),
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setPage(1);
  };

  useEffect(() => {
    setTotalPages(Math.ceil(totalItems / itemsPerPage) || 1);
  }, [totalItems, itemsPerPage]);

  const handleCheckboxChange = (appId) => {
    setSelectedApplications((prevSelected) =>
      prevSelected.includes(appId)
        ? prevSelected.filter((id) => id !== appId)
        : [...prevSelected, appId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedApplications([]);
    } else {
      setSelectedApplications(applications.map((app) => app._id));
    }
    setSelectAll(!selectAll);
  };

  console.log("selectedApplications", selectedApplications);

    const normalizeId = (rawId) => {
    if (!rawId) return "";
    const match = rawId.toUpperCase().match(/(SUW)[\s\-]?(\d+)/);
    return match ? `${match[1]}${match[2]}` : rawId.toUpperCase();
  };

    const hasReadPermission = (permissions, resourceKey) => {
    const perm = permissions?.find((p) => p.resource === resourceKey);
    return perm?.read === true;
  };
  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-2 bg-gray-100 ">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
            <input
              type="text"
              placeholder="Search by name or email"
              className="p-2 border rounded w-full md:w-1/3"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="flex items-center gap-2">
                  {hasReadPermission(userData.permissions, "analytic_recruitment") && (
            <Link
              to="/analytics/recruitment"
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
            >
              Analytics
            </Link>
            
                  )}
            <select
              className="p-2 border rounded"
              value={itemsPerPage}
              onChange={handleLimitChange}
            >
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
            </div>
            {selectedApplications.length > 0 && (
              <button
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded flex items-center gap-2"
                onClick={() => setIsModalOpen(true)}
              >
                Assign
              </button>
            )}
          </div>

          {loading ? (
            <SuwasthiLoader />
          ) : (
            <div className="bg-white shadow-md rounded-lg p-4 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-3">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 text-left">Application ID</th>
                    <th className="p-3 text-left">Name</th>
                    <th className="p-3 text-left">Email</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Position</th>
                    <th className="p-3 text-left">Location</th>
                    <th className="p-3 text-left">Reference</th>
                    <th className="p-3 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredApps.map((app, index) => (
                    <motion.tr
                      key={app._id}
                      className={`border-b ${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      }`}
                      variants={listVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          checked={selectedApplications.includes(app._id)}
                          onChange={() => handleCheckboxChange(app._id)}
                        />
                      </td>
                      <td>
                        {app.id}
                      </td>
                      <td className="p-3">
                        {app?.candidateSnapshot?.firstName}{" "}
                        {app?.candidateSnapshot?.lastName}
                      </td>
                      <td className="p-3">{app.candidateSnapshot?.email}</td>
                    <td className="p-2 text-[12px]">
                        {(() => {
                          const status = app.applicationStatus?.toLowerCase();
                          let colorClasses = "";
                          let label = app.applicationStatus || "Unknown";

                          switch (status) {
                            case "applied":
                              colorClasses =
                                "bg-green-100 text-green-700 border-green-300";
                              break;

                            case "shortlisted":
                              colorClasses =
                                "bg-blue-100 text-blue-700 border-blue-300";
                              break;

                            case "screening":
                              colorClasses =
                                "bg-cyan-100 text-cyan-700 border-cyan-300";
                              break;

                            case "interviewing":
                            case "interview":
                              colorClasses =
                                "bg-indigo-100 text-indigo-700 border-indigo-300";
                              break;

                            case "selected":
                              colorClasses =
                                "bg-emerald-100 text-emerald-700 border-emerald-300";
                              break;

                            case "offered":
                              colorClasses =
                                "bg-sky-100 text-sky-700 border-sky-300";
                              break;

                            case "not joined":
                            case "not-joined":
                              colorClasses =
                                "bg-orange-100 text-orange-700 border-orange-300";
                              break;

                            case "joined":
                              colorClasses =
                                "bg-teal-100 text-teal-700 border-teal-300";
                              break;

                            case "training":
                              colorClasses =
                                "bg-violet-100 text-violet-700 border-violet-300";
                              break;

                            case "onboarding":
                              colorClasses =
                                "bg-blue-100 text-blue-700 border-blue-300";
                              break;

                            case "hired":
                              colorClasses =
                                "bg-green-200 text-green-800 border-green-400";
                              break;

                            case "rejected":
                              colorClasses =
                                "bg-red-100 text-red-700 border-red-300";
                              break;

                            case "on hold":
                            case "on-hold":
                              colorClasses =
                                "bg-yellow-100 text-yellow-700 border-yellow-300";
                              break;

                            case "abscond":
                              colorClasses =
                                "bg-gray-200 text-gray-700 border-gray-300";
                              break;

                            default:
                              colorClasses =
                                "bg-gray-100 text-gray-600 border-gray-300";
                              break;
                          }

                          return (
                            <span
                              className={`px-2 py-1 border rounded-full text-[11px] font-medium capitalize tracking-wide ${colorClasses}`}
                            >
                              {label}
                            </span>
                          );
                        })()}
                      </td>

                      <td className="p-2 text-[12px]">{app.positionTitle}</td>
                      <td className="p-2 text-[12px]">{app.location}</td>
                      <td className="p-2 text-[12px]">
                        {(() => {
                          const refType = app.referenceDetails?.referenceType;
                          let referenceName = "";
                          let referenceId = "";

                          if (refType === "employee") {
                            referenceName = `EMP-${
                              app.referenceDetails.employeeName || ""
                            }`;
                            referenceId = normalizeId(
                              app.referenceDetails.employeeId || ""
                            );
                          } else if (refType === "recruiter") {
                            referenceName = `HR-${
                              app.referenceDetails.recruiterName || ""
                            }`;
                            referenceId = `SUW-${
                              app.referenceDetails.recruiterId || ""
                            }`;
                          } else if (refType === "consultancy") {
                            referenceName = `${
                              app.referenceDetails.consultancyReference || ""
                            }`;
                            referenceId = "Consultancy";
                          } else if (refType === "other") {
                            referenceName = `OTHER-${
                              app.referenceDetails.otherReference || ""
                            }`;
                            referenceId = "N/A";
                          } else if (refType === "walkin") {
                            referenceName = `WALKIN`;
                            referenceId = "N/A";
                          } else {
                            referenceName = "N/A";
                            referenceId = "N/A";
                          }

                          // Return JSX
                          return (
                            <div className="flex flex-col text-gray-700">
                              <span className="font-medium">
                                {referenceName}
                              </span>
                              <span className="text-gray-500 text-[11px]">
                                {referenceId}
                              </span>
                            </div>
                          );
                        })()}
                      </td>

                      <td className="p-3 flex gap-2">
                        <motion.button
                          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                          whileHover={{ scale: 1.1 }}
                          onClick={() =>
                            handleView(app._id, app.interviewStatus)
                          }
                        >
                          Manage
                        </motion.button>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {isModalOpen && (
          <AssignRoleModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedApplications={selectedApplications}
          />
        )}
        <Pagination
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </Container>
    </Layout>
  );
};

export default Interviews;